import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererStatus from "@/components/visit-point/list/cell-renderer/CellRendererStatus.vue";
import CellRendererCheckPickup from "@/components/optimization/cell-renderer/CellRendererCheckPickup.vue";
import CellRendererCheckDelivery from "@/components/optimization/cell-renderer/CellRendererCheckDelivery.vue";
import CellRenderCustomTooltip from "@/components/optimization/cell-renderer/CellRenderCustomTooltip.vue";
import CellRenderCustomHeader from "@/components/optimization/cell-renderer/CellRenderCustomHeader.vue";
import CellRendererAdditionalFields from "@/components/visit-point/list/cell-renderer/CellRendererAdditionalFields.vue";
import moduleMap from "@/store/map/moduleMap.js";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const visitPoinListOptimization = {
	name: "VisitPoinListOptimization",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					cellRendererAdditionalFields: false,
					showPopup: false,
					showMaximizeBtn: false,
					showActions: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		status_id: {
			type: Array,
			default: () => [],
		},
		maximize: {
			type: Boolean,
			default: true,
		},
		circleList: {
			type: Array,
			default: () => [],
		},
		polygonList: {
			type: Array,
			default: () => [],
		},
		typeSelected: {
			type: String,
			default: "",
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererStatus,
		CellRendererAdditionalFields,
		CellRendererCheckPickup,
		CellRendererCheckDelivery,
		CellRenderCustomTooltip,
		CellRenderCustomHeader,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			isModeSelected: false,
			showSelected: false,
			searchQuery: [],
			arrayVisitPoint: [],
			additionalField: null,
			additionalOptions: [],
			isMounted: false,
			markers: [],
			tooltipShowDelay: null,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 3,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererStatus,
				CellRendererAdditionalFields,
				CellRendererCheckPickup,
				CellRendererCheckDelivery,
				CellRenderCustomTooltip,
				CellRenderCustomHeader,
			},
		};
	},
	watch: {
		searchField(val) {
			if (val !== "AdditionalFields") {
				this.additionalField = null;
			}
		},
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status_name", obj.value);
		},
		isVerifiedFilter(obj) {
			let val = "";
			if (obj.value === "all") {
				val = "all";
			} else if (obj.value === "yes") {
				val = "true";
			} else {
				val = "false";
			}
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		currentPageLocal(page) {
			this.getVisitPoint(page);
		},
		quantityElementPage() {
			this.getVisitPoint(1);
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let columns = [
				{
					headerComponentFramework: "CellRenderCustomHeader",
					headerComponentParams: {
						displayName: this.$t("PICKUP"),
						isChecked: false,
						onCheckboxChange: (isChecked) => {
							this.selectOrDeselectAll("pickup", isChecked);
						},
					},
					field: "isPickup",
					width: 112,
					cellRendererFramework: "CellRendererCheckPickup",
					sortable: false,
					pinned: "left",
					cellStyle: {textAlign: "center"},
					headerName: this.$t("PICKUP"),
				},
				{
					headerComponentFramework: "CellRenderCustomHeader",
					headerComponentParams: {
						displayName: this.$t("DELIVERY"),
						isChecked: false,
						onCheckboxChange: (isChecked) => {
							this.selectOrDeselectAll("delivery", isChecked);
						},
					},
					field: "isDelivery",
					width: 112,
					cellRendererFramework: "CellRendererCheckDelivery",
					sortable: false,
					pinned: "left",
					cellStyle: {textAlign: "center"},
					headerName: this.$t("DELIVERY"),
				},
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					width: 220,
				},
				{
					headerName: this.$t("Routing.Table.Latitude"),
					field: "cx",
					width: 170,
				},
				{
					headerName: this.$t("Routing.Table.Longitude"),
					field: "cy",
					width: 170,
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.Department"),
					field: "department",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.City"),
					field: "city",
					width: 200,
				},
				{
					headerName: this.$t("Routing.Table.InitHour"),
					field: "init_hour_window",
					width: 150,
				},
				{
					headerName: this.$t("Routing.Table.EndHour"),
					field: "end_hour_window",
					width: 150,
				},
				{
					headerName: this.$t("Routing.CreateVisitPoint.ServiceTime"),
					field: "time_service",
					width: 180,
				},
				{
					headerName: this.$t("Priority"),
					field: "priority",
					width: 150,
				},
				{
					headerName: this.$t("TypeConfig.Form.Status"),
					field: "status_name",
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
			];
			if (this.customConfig.cellRendererAdditionalFields) {
				columns.push({
					headerName: this.$t("AdditionalFields"),
					field: "additional_info",
					width: 350,
					cellRendererFramework: "CellRendererAdditionalFields",
				});
			}
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.visitPoints === undefined ||
				this.$store.state.moduleVisitPoint.visitPoints === "" ||
				this.$store.state.moduleVisitPoint.visitPoints === null
				? []
				: this.$store.state.moduleVisitPoint.visitPoints;
		},
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup;
		},
		getCheckedVisitPointsDelivery() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery;
		},
		totalVisitPointChecked() {
			let totalChecked =
				this.getCheckedVisitPointsPickup && this.getCheckedVisitPointsPickup.length > 0
					? this.getCheckedVisitPointsPickup.length
					: 0;
			return totalChecked;
		},
		totalVisitPointCheckedDelivery() {
			let totalChecked =
				this.getCheckedVisitPointsDelivery && this.getCheckedVisitPointsDelivery.length > 0
					? this.getCheckedVisitPointsDelivery.length
					: 0;
			return totalChecked;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		visitPointsMarkers() {
			return this.$store.state.moduleMap.visitPointsMarkers === undefined ||
				this.$store.state.moduleMap.visitPointsMarkers === "" ||
				this.$store.state.moduleMap.visitPointsMarkers === null
				? []
				: this.$store.state.moduleMap.visitPointsMarkers;
		},
	},
	methods: {
		selectOrDeselectAll(field, isChecked) {
			const itemsToAdd = [];
			this.gridApi.forEachNode((node) => {
				this.updateNodeAndCollectItems(node, field, isChecked, itemsToAdd);
			});
			this.updateStore(field, isChecked, itemsToAdd);
			this.gridApi.refreshView();
		},
		updateNodeAndCollectItems(node, field, isChecked, itemsToAdd) {
			const property = field === "pickup" ? "isPickup" : "isDelivery";
			node.data[property] = isChecked;
			if (isChecked) {
				itemsToAdd.push(node.data);
			}
		},
		updateStore(field, isChecked, itemsToAdd) {
			const mutationPrefix = field === "pickup" ? "PICKUP" : "DELIVERY";
			if (isChecked) {
				this.$store.commit(`moduleVisitPoint/SET_VISIT_POINT_CHECKED_${mutationPrefix}`, itemsToAdd);
			} else {
				this.$store.commit(`moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_${mutationPrefix}`);
			}
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getVisitPointsAdditionalInfo() {
			const payload = {
				fields: ["json_properties"],
				sort: "desc",
				status_id: this.status_id,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointAdditionalFields", payload)
				.then((res) => {
					const additionalInfo = [];
					res.records.forEach((data) => {
						if (data.json_properties !== null)
							data.json_properties.forEach((info) => additionalInfo.push(info));
					});
					this.getAdditionalInfo(additionalInfo);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		async getVisitPoint(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				sort: "desc",
				status_id: this.status_id,
				order_by: ["id"],
			};
			await this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", payload)
				.then((res) => {
					this.$emit("getVisitPointsInMapEmit", res.records);
					Object.assign(this.pagination, res.pagination);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchVisitPoint() {
			let searchQueryList = [];
			if (this.searchField === "AdditionalFields") {
				this.additionalField.forEach((field) => {
					searchQueryList.push({key: field.label, value: field.value});
				});
			} else {
				searchQueryList = this.searchQuery.map(({value}) => value);
			}
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				address: this.searchField === "Address" ? searchQueryList : [],
				department: this.searchField === "Department" ? searchQueryList : [],
				city: this.searchField === "City" ? searchQueryList : [],
				additional_info: this.searchField === "AdditionalFields" ? searchQueryList : [],
				status_id: this.status_id,
				order_by: ["id"],
				sort: "desc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", dataPage)
				.then((res) => {
					this.$emit("getVisitPointsInMapEmit", res.records);
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		async onGridReady() {},
		rowSelected(event) {},
		setDefaultSelectedRow() {
			const relatedIdsPickup = this.getCheckedVisitPointsPickup;
			if (relatedIdsPickup.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIdsPickup.some((r) => r.id === node.data.id && r.isPickup === true);
					node.setDataValue("isPickup", valid);
				});
			}
			const relatedIdsDelivery = this.getCheckedVisitPointsDelivery;
			if (relatedIdsDelivery.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIdsDelivery.some((r) => r.id === node.data.id && r.isDelivery === true);
					node.setDataValue("isDelivery", valid);
				});
			}
		},
		refreshVisitPoint() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.isModeSelected = false;
			this.$emit("getModeSelectedEmit", this.isModeSelected);
			this.getVisitPoint(1);
			if (this.circleList.length > 0) {
				for (let circle of this.circleList) {
					if (circle.typeService === "all") {
						circle.setMap(null);
					}
				}
			}
			if (this.polygonList.length > 0) {
				for (let polygon of this.polygonList) {
					if (polygon.typeService === "all") {
						polygon.setMap(null);
					}
				}
			}
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP");
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY");
		},
		setSearchField(val) {
			this.searchField = val;
		},
		selectedVisitsPoint(initValue) {
			this.showSelected = true;
			if (
				this.getCheckedVisitPointsPickup.length >= initValue ||
				this.getCheckedVisitPointsDelivery.length >= initValue
			) {
				const filterPickup = this.getCheckedVisitPointsPickup.filter(
					(data) => data.isPickup === true && data.isDelivery === false
				);
				const filterDelivery = this.getCheckedVisitPointsDelivery.filter(
					(data) => data.isDelivery === true && data.isPickup === false
				);
				const filterAll = this.getCheckedVisitPointsPickup.filter(
					(data) => data.isPickup === true && data.isDelivery === true
				);
				this.gridApi.setRowData([...filterPickup, ...filterDelivery, ...filterAll]);
				this.isModeSelected = true;
				this.$emit("showSelectedVisitsPointEmit", [...filterPickup, ...filterDelivery, ...filterAll]);
				Anuket.fitBoundsLatLngArray(
					[...filterPickup, ...filterDelivery, ...filterAll].map((data) => {
						if ((data.cy != null || data.cy != 0) && (data.cx != null || data.cx != 0))
							return {lat: data.cy, lng: data.cx};
					})
				);
			}
			this.$emit("getModeSelectedEmit", this.isModeSelected);
		},
		removeChips() {
			this.showSelected = false;
			this.isModeSelected = false;
			this.$emit("getModeSelectedEmit", this.isModeSelected);
			if (this.getCheckedVisitPointsPickup.length > 0 || this.getCheckedVisitPointsDelivery.length > 0) {
				this.gridApi.setRowData(this.usersData);
				this.setDefaultSelectedRow();
				this.$emit("getVisitPointsInMapEmit", this.usersData);
			}
		},
		clearSearch() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.isModeSelected = false;
			this.searchVisitPoint();
		},
		selectRowsShape(visitPointArray, is_pickup, is_delivery) {
			return new Promise((resolve, reject) => {
				try {
					if (visitPointArray && visitPointArray.length > 0) {
						this.gridApi.forEachNode((node) => {
							this.processNode(node, visitPointArray, is_pickup, is_delivery);
						});
					}
					this.$vs.loading.close();
					resolve(true);
				} catch (e) {
					this.$vs.loading.close();
					reject(e);
				}
			});
		},
		processNode(node, visitPointArray, is_pickup, is_delivery) {
			for (const visitPoint of visitPointArray) {
				if (visitPoint.id === node.data.id && !node.isSelected()) {
					this.updateNodeValues(node, is_pickup, is_delivery);
					break; // Optimization: Exit loop after finding a match
				}
			}
		},
		updateNodeValues(node, is_pickup, is_delivery) {
			if (is_pickup && is_delivery) {
				this.setPickupDelivery(node);
			} else if (is_pickup) {
				this.setPickup(node);
			} else if (is_delivery) {
				this.setDelivery(node);
			}
		},
		setPickupDelivery(node) {
			node.setDataValue("isPickup", true);
			node.setDataValue("isDelivery", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_PICKUP", node.data);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DELIVERY", node.data);
		},
		setPickup(node) {
			node.setDataValue("isPickup", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_PICKUP", node.data);
		},
		setDelivery(node) {
			node.setDataValue("isDelivery", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DELIVERY", node.data);
		},
		getMarkersInsideCircle(circle) {
			const center = circle.getCenter();
			const radius = circle.getRadius();
			const selectedPoints = [];
			this.$vs.loading();
			return new Promise((resolve, reject) => {
				try {
					this.visitPointsMarkers.features.forEach((feature) => {
						const point = new google.maps.LatLng(
							feature.geometry.coordinates[1],
							feature.geometry.coordinates[0]
						);
						if (google.maps.geometry.spherical.computeDistanceBetween(center, point) <= radius) {
							selectedPoints.push(feature);
						}
					});
					circle.arrayVisitPoint = selectedPoints.map((item) => item.properties);
					resolve(true);
				} catch (e) {
					reject(e);
				}
			});
		},
		getMarkersInsidePolygon(polygon) {
			this.$vs.loading();
			return new Promise((resolve, reject) => {
				try {
					const selectedPoints = this.visitPointsMarkers.features.filter((feature) => {
						const point = new google.maps.LatLng(
							feature.geometry.coordinates[1],
							feature.geometry.coordinates[0]
						);
						return google.maps.geometry.poly.containsLocation(point, polygon);
					});
					polygon.arrayVisitPoint = selectedPoints.map((item) => item.properties);
					resolve(true);
				} catch (e) {
					reject(e);
				}
			});
		},
		async validateMarkerSelectionCircle(circle, is_pickup, is_delivery) {
			if (is_pickup && !is_delivery) {
				circle.setOptions({strokeColor: "#420d91", fillColor: "#420d91"});
				circle.typeService = "pickup";
			} else if (is_delivery && !is_pickup) {
				circle.setOptions({strokeColor: "#ff9f43", fillColor: "#ff9f43"});
				circle.typeService = "delivery";
			} else {
				circle.typeService = "all";
			}
			await this.getMarkersInsideCircle(circle);
			this.selectRowsShape(circle.arrayVisitPoint, is_pickup, is_delivery).then((res) => {
				if (res) this.$vs.loading.close();
			});
		},
		async validateMarkerSelectionPolygon(polygon, is_pickup, is_delivery) {
			if (is_pickup && !is_delivery) {
				polygon.setOptions({strokeColor: "#420d91", fillColor: "#420d91"});
				polygon.typeService = "pickup";
			} else if (is_delivery && !is_pickup) {
				polygon.setOptions({strokeColor: "#ff9f43", fillColor: "#ff9f43"});
				polygon.typeService = "delivery";
			} else {
				polygon.typeService = "all";
			}
			await this.getMarkersInsidePolygon(polygon);
			this.selectRowsShape(polygon.arrayVisitPoint, is_pickup, is_delivery).then((res) => {
				if (res) this.$vs.loading.close();
			});
		},
		onPaste(event) {
			let clipped = event.clipboardData.getData("text/plain").split(",");
			if (clipped.length > 0) {
				clipped.forEach((item) => {
					this.searchQuery.push({
						key: "",
						value: item,
					});
				});
				this.searchVisitPoint();
				event.target.blur();
			}
		},
		clearInput() {
			if (this.searchQuery.length <= 0) this.searchVisitPoint();
		},
		getAdditionalInfo(data) {
			this.additionalOptions = data.map((info) => {
				return {label: info.label, value: info.value};
			});
		},
		handleMaximizeEmit() {
			this.$emit("handleMaximize");
		},
	},
	mounted() {
		const dataInputPickup = document.querySelector("#searchdataPickup");
		dataInputPickup.addEventListener("paste", this.onPaste, false);
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.getVisitPointsAdditionalInfo();
		this.gridApi = this.gridOptions.api;
		this.isMounted = true;
		this.$emit("gridApiEmit", this.gridApi);
		this.$emit("mountedVisitPointList", this.isMounted);
	},
	created() {
		this.tooltipShowDelay = 500;
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
	},
};
